import { createApp } from 'vue'
import Calc from './Calc.vue'
//import store from './store'
require('@/assets/css/main.scss');

createApp(Calc).mount('#wcalc')

